import SocialNetworksAPI from './social-networks-api';

export default SocialNetworksAPI;
